import { useState, useEffect } from "react";
import { getConfig, updateConfig } from "../../api/settings";
import "./style.css";
import { Select, message, List, Slider } from "antd";
const { Option } = Select;

const DeepseekConfig = () => {
  const [formState, setFormState] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  const getConfigData = async () => {
    try {
      const response = await getConfig();
      if (response) {
        setFormState((prevState) => ({
          ...prevState,
          deepseekModel: response.deepseekModel,
          deepseekTemperature: response.deepseekTemperature,
          deepseekMaxTokens: response.deepseekMaxTokens,
          deepseekTopP: response.deepseekTopP,
          deepseekTopK: response.deepseekTopK,
          deepseekRepetitionPenalty: response.deepseekRepetitionPenalty,
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getConfigData();
  }, []);

  const handleUpdateClick = async () => {
    setIsEditing(!isEditing);
    if (isEditing) {
      const response = await updateConfig(formState);
      if (response) {
        message.success(response.message);
      } else {
        message.error(response.message);
      }
    }
  };

  const data = [
    { title: "Model", description: formState?.deepseekModel || "" },
    {
      title: "Temperature (between 0 and 2)",
      description: formState.deepseekTemperature || "",
    },
    {
      title: "Max Tokens (up to 16384 tokens)",
      description: formState?.deepseekMaxTokens || "",
    },
    {
      title: "Top P (between 0 and 1)",
      description: formState?.deepseekTopP || "",
    },
    { 
      title: "Top K (between 1 and 100)",
      description: formState?.deepseekTopK || "", 
    },
    {
      title: "Frequency Penalty (between 1 and 2)",
      description: formState?.deepseekRepetitionPenalty || "",
    },
  ];

  return (
    <>
      <div className="">
        <List
          header={<div>Change Deepseek Settings</div>}
          size="small"
          bordered
          dataSource={data}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                title={item.title}
                description={
                  item.title === "Model" ? (
                    <Select
                      className="editConfigSelectField"
                      value={formState?.deepseekModel || ""}
                      onChange={(value) =>
                        setFormState({
                          ...formState,
                          deepseekModel: value,
                        })
                      }
                      disabled={!isEditing}
                      style={{ width: "300px" }}
                    >
                      <Option value="deepseek-ai/DeepSeek-R1">
                        DeepSeek-R1
                      </Option>
                      <Option value="deepseek-ai/DeepSeek-V3">
                        DeepSeek-V3
                      </Option>
                    </Select>
                  ) : item.title === "Temperature (between 0 and 2)" ? (
                    <Slider
                      min={0}
                      max={2}
                      step={0.1}
                      value={formState.deepseekTemperature || 0}
                      onChange={(value) =>
                        setFormState({
                          ...formState,
                          deepseekTemperature: value,
                        })
                      }
                      disabled={!isEditing}
                      style={{ width: "300px" }}
                    />
                  ) : item.title === "Max Tokens (up to 16384 tokens)" ? (
                    <Slider
                      min={0}
                      max={16384}
                      step={10}
                      value={formState.deepseekMaxTokens || 0}
                      onChange={(value) =>
                        setFormState({
                          ...formState,
                          deepseekMaxTokens: value,
                        })
                      }
                      disabled={!isEditing}
                      style={{ width: "300px" }}
                    />
                  ) : item.title === "Top P (between 0 and 1)" ? (
                    <Slider
                      min={0}
                      max={1}
                      step={0.1}
                      value={formState.deepseekTopP || 0}
                      onChange={(value) =>
                        setFormState({
                          ...formState,
                          deepseekTopP: value,
                        })
                      }
                      disabled={!isEditing}
                      style={{ width: "300px" }}
                    />
                  ) : item.title === "Top K (between 1 and 100)" ? (
                    <Slider
                      min={0}
                      max={100}
                      step={1}
                      value={formState.deepseekTopK || 0}
                      onChange={(value) =>
                        setFormState({
                          ...formState,
                          deepseekTopK: value,
                        })
                      }
                      disabled={!isEditing}
                      style={{ width: "300px" }}
                    />
                  ) : item.title === "Frequency Penalty (between 1 and 2)" ? (
                    <Slider
                      min={1}
                      max={2}
                      step={0.01}
                      value={formState.deepseekRepetitionPenalty || 1}
                      onChange={(value) =>
                        setFormState({
                          ...formState,
                          deepseekRepetitionPenalty: value,
                        })
                      }
                      disabled={!isEditing}
                      style={{ width: "300px" }}
                    />
                  ) : (
                    item.description
                  )
                }
              />
            </List.Item>
          )}
        />
        <div className="text-end">
          <a
            onClick={handleUpdateClick}
            key="list-loadmore-edit"
            className="btn btn-outline-dark"
          >
            {isEditing ? "update" : "edit"}
          </a>
          {isEditing && (
            <a
              onClick={() => setIsEditing(!isEditing)}
              key="list-loadmore-cancel"
              className="btn btn-outline-dark"
            >
              cancel
            </a>
          )}
        </div>
      </div>
    </>
  );
};

export default DeepseekConfig;
